import React, { PureComponent } from "react";
import classNames from "../../utils/classnames";

export class TextArea extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      textCounter: this.props.defaultValue ? this.props.defaultValue.length : 0
    };

    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(e) {
    this.setState({
      textCounter: e.target.value.length
    });

    if (this.props.onChange && typeof this.props.onChange === "function")
      this.props.onChange(e);
  }

  render() {
    const { className, children, showCounter, maxLength, onChange, ...others } = this.props;
    const cls = classNames({
      "weui-textarea": true
    }, className);

    return (
      <>
        <textarea className={ cls } maxLength={ maxLength } onChange={ this.handleChange } { ...others }>
          { children }
        </textarea>
        {
          showCounter
            ? <div className="weui-textarea-counter" aria-live="polite">
              <span>{ this.state.textCounter }</span>{ maxLength ? "/" + maxLength : false }
            </div>
            : false
        }
      </>
    );
  }
}
